import { TypePolicies } from '@apollo/client';
import { ListTeamsQueryVariables } from '../graphql/generated';
import { cacheMergePaginatedList } from './cache.util';

const TeamCacheTypePolicies: TypePolicies = {
  Query: {
    fields: {
      listTeams: {
        keyArgs: ['input', ['userId', 'active']],
        merge: (existing, incoming, { variables }) => {
          return cacheMergePaginatedList<ListTeamsQueryVariables>(
            existing,
            incoming,
            variables as ListTeamsQueryVariables
          );
        },
      },
    },
  },
};

export { TeamCacheTypePolicies };
